import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentClassificationCollapse from "./document-classification/document-classification-collapse.vue";
import { mapGetters, mapActions } from "vuex";
import { DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION, DOCUMENTS_FOR_APPLICATION, COMMENTS_FOR_APPLICATION } from "../../store/documents-getters";
import { ORDER_DOCUMENTS_REQUESTS } from "../../store/documents-actions";
import draggable from "vuedraggable";
import { orderBy, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentClassificationContainer",
  components: {
    DocumentClassificationCollapse,
    draggable
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      nonce: 0,
      sorting: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("DocumentsStore", [DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION, DOCUMENTS_FOR_APPLICATION, COMMENTS_FOR_APPLICATION])), {}, {
    classifications() {
      return this.DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION(this.applicationId);
    },
    orderedClassifications: {
      get() {
        const classifications = values(this.classifications.byId);
        return orderBy(classifications, "customOrder", "asc");
      },
      set(value) {
        this.ORDER_DOCUMENTS_REQUESTS({
          documentsClassifications: value,
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        });
        this.nonce++;
      }
    },
    documents() {
      return this.DOCUMENTS_FOR_APPLICATION(this.applicationId);
    },
    comments() {
      return this.COMMENTS_FOR_APPLICATION(this.applicationId);
    },
    noClassifications() {
      return this.classifications.allIds.length === 0;
    }
  }),
  methods: _objectSpread({}, mapActions("DocumentsStore", [ORDER_DOCUMENTS_REQUESTS]))
});